import { createReducer } from 'reduxsauce';
import { SET_COMMUNITIES } from '../../actions/community/communityActions';
import {
  SET_COMMUNITY_FILTER_TYPE,
  SET_COMMUNITY_POSTING_ID
} from '../../actions/mentioning/mentioningActions';
import { ALL_COMMUNITIES_CHOICE } from '../../../utils/community/communityConstants';

const INITIAL_STATE = {
  communityFilter: ALL_COMMUNITIES_CHOICE,
  communities: {},
  communityPostId: undefined
};

const setCommunities = (state, action) => {
  const { communities } = action.payload;
  return {
    ...state,
    communities
  };
};

const setCommunityFilter = (state, action) => {
  const { communityFilter } = action.payload;
  return {
    ...state,
    communityFilter
  };
};

const setCommunityPostingId = (state, action) => {
  const { communityPostId } = action.payload;
  return {
    ...state,
    communityPostId
  };
};

export default createReducer(INITIAL_STATE, {
  [SET_COMMUNITIES]: setCommunities,
  [SET_COMMUNITY_FILTER_TYPE]: setCommunityFilter,
  [SET_COMMUNITY_POSTING_ID]: setCommunityPostingId
});
